import { Link } from 'react-router-dom'

export const Footer = () => {
    return (
        <footer className="flex flex-col gap-2 w-full">
            <div className="flex gap-2">
                <p className="text-[clamp(12px,3vw,16px)] text-[#898989]">
                    이미 계정이 있으신가요?
                </p>
                <Link className="text-[clamp(12px,3vw,16px)] text-[#007aff] underline" to="/login">
                    로그인 하기
                </Link>
            </div>
            <div className="flex gap-2">
                <p className="text-[clamp(12px,3vw,16px)] text-[#898989]">
                    이전에 탈퇴한 적이 있으신가요?
                </p>
                <a
                    className="text-[clamp(12px,3vw,16px)] text-[#007aff] underline"
                    href="https://queenliveseller.channel.io/workflows/697713"
                    target="_blank"
                    rel="noreferrer"
                >
                    다시 가입 신청하기
                </a>
            </div>
        </footer>
    )
}
